export default {
  CLIENT_ID: '693034939601-d9kju9035g05lq0mclpb5m2dfum9nj86.apps.googleusercontent.com',
  UPLOAD_SCOPE: 'https://www.googleapis.com/auth/youtube.upload',
  RESPONSE_TYPE: 'code',
  ACCESS_TYPE: 'offline'
};